export const LANG = {
  VI: 'vi',
  EN: 'en',
  VI_VN: 'vi_VN',
  EN_US: 'en_US'
}
